import type {Task} from '../types/task'
import {useQuery} from '@github-ui/react-query'
import type {IdToPullRequestMap} from '../types/pull'

export function getSortedResourceIds(tasks: Task[]): string {
  const ids = tasks ? tasks.map(task => task.resource_id) : []
  // Dedupe before sorting
  const uniqueIds = Array.from(new Set(ids))
  return uniqueIds.sort((a, b) => Number(a) - Number(b)).join(',')
}

export function usePullRequests({
  tasks,
  sessionsPollingInterval = 3000,
  initialPullRequestsMap = {},
}: {
  tasks: Task[]
  sessionsPollingInterval?: number | false
  initialPullRequestsMap?: IdToPullRequestMap
}) {
  const pullRequestIds = getSortedResourceIds(tasks)

  return useQuery<IdToPullRequestMap>({
    queryKey: ['agent-sessions-pull-requests', pullRequestIds],
    queryFn: async () => {
      const response = await fetch(
        `/copilot/agent-sessions/pull-requests?pull_request_ids=${encodeURIComponent(pullRequestIds)}`,
        {
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
      )

      if (!response.ok) {
        throw new Error('Failed to fetch pull requests')
      }

      const data = await response.json()
      return data.pull_requests
    },
    initialData: initialPullRequestsMap,
    refetchInterval: sessionsPollingInterval,
    refetchIntervalInBackground: false,
    enabled: pullRequestIds.length > 0,
  })
}
